export const CART_ADD_ITEM = 'CART_ADD_ITEM'
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM'
export const CART_SAVE_SHIPPING_ADRESSE = 'CART_SAVE_SHIPPING_ADRESSE'
export const CART_SAVE_PAYMENT = 'CART_SAVE_PAYMENT'
export const CART_MODAL_TOGGLE = 'CART_MODAL_TOGGLE'